import { IArticle, IStrippedArticlePostCategory } from '../schemas/article/types';

/**
 * Find full-description of a tag by name from articles.
 * @param activeCategory
 * @param articles
 */
export const getActiveArticleCategory = (
  activeCategory: string,
  articles?: IArticle[],
): IStrippedArticlePostCategory | null => {
  if (!activeCategory) {
    return null;
  }
  for (const article of articles || []) {
    const tag = article?.terms?.category.find((articleTag) => articleTag.slug === activeCategory);
    if (tag) {
      return tag;
    }
  }
  return { slug: activeCategory };
};
